module.exports = __webpack_public_path__ + "static/img/10.9cff139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/10.jpg
// module id = RvKO
// module chunks = 1